function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.hours').html(hours)
      $('.minutes').html(minutes)
      $('.seconds').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    var swiper = new Swiper('.mySwiper', {
      spaceBetween: 20,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
    })
    var swiper2 = new Swiper('.mySwiper2', {
      spaceBetween: 10,
      thumbs: {
        swiper: swiper,
      },
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    var swiper3 = new Swiper('.mySwiper3', {
      slidesPerView: 'auto',
      spaceBetween: 17,
      centeredSlides: true,
      loop: true, //循环滚动
      freeMode: true,
      speed: 6500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    //加减
    let sp_price1 = 9.99
    let sp_price2 = 29.99
    let prods = window.prods
    function getCur() {
      let color = $('#color div.active').attr('data-val')
      let size = $('#Size div.active').attr('data-val')
      return prods.filter(
        item => item.option2 == color && item.option1 == size
      )[0]
    }
    function changePrice() {
      let num = $('#calcNumber').val()
      let price = ((getCur().price * num) / 100).toFixed(2)
      let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
      // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      // $(".product-part .sp-brand1 .sp-off").html(off_font);
    }
    function calcTotal(price, num) {
      let _result = Number(price) * Number(num)
      if (_result > 50) {
        // $('.product-part .sp-tip').css('display', 'flex')
        $('.product-part .btn-free').css('display', 'flex')
      } else {
        // $('.product-part .sp-tip').hide()
        $('.product-part .btn-free').hide()
      }
      return _result.toFixed(2)
    }
    // 数字框
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
      }
      // changePrice()
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      // changePrice()
    })
    // const tabs = $('.sp-tab')
    // let currentIndex = 0
    // function nextTabFunc() {
    //   const currentTab = tabs[currentIndex]
    //   currentTab.classList.add('sp-tab-ani')
    //   let nextIndex = (currentIndex + 1) % tabs.length
    //   const nextTab = tabs[nextIndex]
    //   setTimeout(() => {
    //     currentTab.classList.remove('sp-tab-ani')
    //   }, 2500),
    //     (currentIndex = (currentIndex + 1) % tabs.length),
    //     setTimeout(nextTabFunc, 1500)
    // }
    // nextTabFunc()
    // style选项
    let typeOptions = $('#Size .option')
    var imgArr = [
     'https://cdn.shopify.com/s/files/1/0875/4885/4556/files/20250428-pro-2.png',
      'https://cdn.shopify.com/s/files/1/0757/3061/6616/files/1_fc5276c8-54af-4e9c-9dd6-f712b854a1aa.png?v=1749540307',
      'https://cdn.shopify.com/s/files/1/0875/4885/4556/files/20250428-pro-1.png',
      'https://cdn.shopify.com/s/files/1/0875/4885/4556/files/20250428-pro-3.png',
      'https://cdn.shopify.com/s/files/1/0757/3061/6616/files/LAST_DAY_SALE_49_OFF_Body_Coverage_Perfector_Waterproof_lightwei.png?v=1749540307',
      'https://cdn.shopify.com/s/files/1/0757/3061/6616/files/15.png?v=1749540307',
    ]
    typeOptions.click(function () {
     var index = $(this).index()
      $('.sp-pro-imgs>img').attr('src', imgArr[index])
      $(this).addClass('active').siblings().removeClass('active')
      changePrice()
    })
    $('#color .option').click(function () {
      var index = $(this).index()
      console.log(index,"index")
      if (index == 1) {
        $(".sp-pro-size").hide()
        $(".sp-pro-size2").show()
      }else {
         $(".sp-pro-size").show()
        $(".sp-pro-size2").hide()
      }
      $(this).addClass('active').siblings().removeClass('active')
      changePrice()
    })
    // $('#Size .option').click(function () {
    //   var index2 = $(this).index()
    //   $(this).addClass('active').siblings().removeClass('active')
    //   if (index2 == 0) {
    //     $('.sp-pro-size').show()
    //      $('.sp-frees2').hide()
    //      $('.sp-frees').show()
    //     $('.sp-pro-size2').hide()
    //   } else if (index2 == 1) {
    //     $('.sp-pro-size').hide()
    //     $('.sp-frees2').show()
    //     $('.sp-frees').hide()
    //     $('.sp-pro-size2').show()
    //   }
    //   changePrice()
    // })
    // $('#color .option').click(function () {
    //   $(this).addClass('active').siblings().removeClass('active')
    //   changePrice()
    // })
    // style选项
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    // 加入购物车
    addCart()
    $('.sp-btn-style').click(function () {
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    // 弹窗 start
    var main_id = ''
    $('.emitCheckout').click(function () {
      console.log('1111')
      main_id = getCur().id
      // main_id = $(this).siblings('.select_span').find('span.on').data('id')
      // window.location.href = "/cart/" + id + ":1"
    })
    let popProduct = window.popProduct

    function getPopProdId() {
      let selectVals = []
      $('.overbuy_wrap .sp-subopt.active').each(function () {
        selectVals.push($(this).data('val'))
      })

      let cur = popProduct.filter(item => {
        let option1 = selectVals[0]
        let option2 = null
        let option3 = null
        if (selectVals[1]) {
          option2 = selectVals[1]
        }
        if (selectVals[2]) {
          option3 = selectVals[2]
        }

        return (
          item.option1 == option1 &&
          item.option2 == option2 &&
          item.option3 == option3
        )
      })

      return cur[0]
    }

    $('.overbuy-select div').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      let cur = getPopProdId()

      if (cur) {
        $('.main-btn').text('GET 10% oFF').removeClass('overbuy_disabled')
        let _price = parseFloat(cur.price / 100).toFixed(2)
        let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(
          2
        )

        $('.overbuy_price span')
          .eq(0)
          .html('£' + _price)
        $('.overbuy_price span')
          .eq(1)
          .html('£' + _compare_at_price)
      } else {
        $('.main-btn').text('Unavailable').addClass('overbuy_disabled')
      }
    })

    window.emitSubmit = function (_type) {
      let num = $('#calcNumber').val()
      if (_type == 'all') {
        // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
        let _id = getPopProdId()?.id
        if (!_id) return
        console.log(_id)

        window.location.href = `/cart/${main_id}:${num},${_id}:1`
      } else {
        window.location.href = `/cart/${main_id}:${num}`
      }
    }

    // 弹窗 end
    function addCart() {
      // 加入购物车
      $('.addCerts').click(function () {
        // do something here
        var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          success: function () {
            $.getJSON(
              window.Shopify.routes.root + 'cart.js',
              function (result) {
                $('#cardNum').html(result.item_count)
                $('#cardNum').removeClass('sp-gray')
                if (result.item_count > 0) {
                  $('.sp-cart .num').css('background', '#cf0101')
                } else {
                  $('.sp-cart .num').css('background', '#919191')
                }
              }
            )
          },
          dataType: 'json',
        })

        var index = $('#Size .option.active').index()
        var img = $('.sp-pro-size')
        if (index == 0) {
          img = $('.sp-pro-size img')
        } else {
          img = $('.sp-pro-size2 img')
        }
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99999',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2 - 15,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - $('header').height() + 250
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
